module.exports = __webpack_public_path__ + "img/big4.49227765.png";